<span *ngIf="label" class="status-label" [ngClass]="[!isActive ? 'inactive' : '', getLabelClass()]">
  {{ label.name }}
</span>
<!-- [matTooltip]="shouldCropLabel && label.name.length > croppedLength ? label.name : null" -->
<!-- {{ shouldCropLabel && label.name.length > croppedLength ? (label.name | slice: 0 : croppedLength) + '...' : label.name }} -->
